import Immutable from 'immutable';
import pluralize from 'pluralize';
import PropTypes from 'prop-types';
import React from 'react';
import { getFormValues, reduxForm } from 'redux-form/immutable';
import { connect } from 'react-redux';

// actions
import { doctorAvailabilitiesCreate, doctorAvailabilitiesDelete } from '../../../actions/doctorActions';
import { tooltipHide, tooltipShow } from '../../../actions/tooltipActions';
import { destroy, initialize } from 'redux-form/immutable';

// components
import { Field } from 'redux-form/immutable';
import { Button, Checkbox } from '../../shared/_form';
import { Tooltip } from '../../shared/_tooltip';

// constants
const FORM_NAME = 'availableDoctors';

class AvailableDoctorsTooltip extends React.Component {
  static propTypes = {
    close:              PropTypes.func.isRequired,
    createAvailability: PropTypes.func.isRequired,
    date:               PropTypes.instanceOf(Object).isRequired,
    deleteAvailability: PropTypes.func.isRequired,
    doctor:             PropTypes.instanceOf(Immutable.Map).isRequired,
    doctorAvailability: PropTypes.instanceOf(Immutable.Map),
    formValues:         PropTypes.instanceOf(Immutable.Map),
    id:                 PropTypes.string.isRequired,
    loading:            PropTypes.bool,
    onClose:            PropTypes.func,
    show:               PropTypes.func.isRequired
  }

  constructor(props) {
    super(props);

    this.state = { data: Immutable.Map() };
  }

  componentWillReceiveProps(nextProps) {
    this._initForm(nextProps);
  }

  render() {
    const { id } = this.props;

    return (
      <div className='calendar__day__doctor-container'>

        { this._renderButton() }

        <Tooltip className='manager__calendar-index__available-doctors-tooltip'
          header='Add and Remove Doctors'
          id={ id }
          onClose={ this._handleClose }>

          { this._renderForm() }

        </Tooltip>
      </div>
    );
  }

  // private

  _handleClose  = this._handleClose.bind(this);
  _handleShow   = this._handleShow.bind(this);
  _handleSubmit = this._handleSubmit.bind(this);

  _handleClose() {
    const { close, id, onClose } = this.props;

    close(id);

    if (onClose) {
      onClose();
    }
  }

  _handleShow() {
    const { id, show } = this.props;

    show(id);
  }

  _handleSubmit(e) {
    e.preventDefault();

    const { createAvailability, date, deleteAvailability, doctorAvailability, formValues, id } = this.props;

    formValues.map((value, doctorId) => {
      const availability = doctorAvailability.filter((a) => a.get('doctor') === doctorId).first();

      if (availability && !value) {
        const params = { id: availability.get('id'), tooltipId: id };

        deleteAvailability(params);
      } else if (!availability && value) {
        const params = {
          date: date.format(),
          doctorId: doctorId,
          tooltipId: id
        };

        createAvailability(params);
      }
    });
  }

  _initForm(props) {
    const { doctor, doctorAvailability, id, initForm, tooltip } = props;

    const active        = ((tooltip.get('data') || Immutable.Map()).get(id) || Immutable.Map()).get('active') || false;
    const doctorResult  = doctor.get('result') || Immutable.List();

    if (active) {
      const form = {};

      doctorResult.forEach((doctorId) => {
        const availability = doctorAvailability.filter((a) => a.get('doctor') === doctorId).first();

        if (availability) {
          form[doctorId] = true;
        } else {
          form[doctorId] = false;
        }
      });

      initForm(form);
    }
  }

  _renderButton() {
    const { doctorAvailability } = this.props;

    const doctorsAvailable = doctorAvailability.size || 0;

    let element = null;

    if (doctorsAvailable === 0) {
      element = (<i className='manager__calendar-index__available-doctors-tooltip__add-doctor-button fa fa-plus' onClick={ this._handleShow } />);
    } else {
      element = (<div onClick={ this._handleShow }>{ `${doctorsAvailable} ${pluralize('doctor', doctorsAvailable)}` }</div>);
    }

    return element;
  }

  _renderCheckbox({ input, meta, ...rest }) {
    const value         = typeof input.value === 'boolean' ? input.value : false,
          _handleChange = input.onChange;

    return <Checkbox checked={ input.value }
      { ...input }
      { ...rest }
      onChange={ _handleChange }
      value={ value } />;
  }

  _renderDoctors() {
    const doctorData    = this.props.doctor.get('data') || Immutable.Map();
    const doctorResult  = this.props.doctor.get('result') || Immutable.List();
    const elements      = [];

    doctorResult.forEach((id) => {
      const doctor  = doctorData.get(id) || Immutable.Map();

      elements.push(
        <div className='form__group tooltip__form__group manager__calendar-index__available-doctors-tooltip__form-group'
          key={ id }>
          <Field component={ this._renderCheckbox } id={ id } name={ id } type='checkbox' />
          <span>{ doctor.get('name') }</span>
        </div>
      );
    });

    return elements;
  }

  _renderForm() {
    const { loading } = this.props;

    const doctorResult  = this.props.doctor.get('result') || Immutable.List();

    let element;

    if (doctorResult.size === 0) {
      element = (
        <div className='manager__calendar-index__available-doctors-tooltip--empty-state'>There are no doctors to add. Please create doctors in the 'Doctors' tab.</div>
      );
    } else {
      element = (
        <form onSubmit={ this._handleSubmit }>
          { this._renderDoctors() }

          <div className='form__submit'>
            <Button className='form__button form__button--purple' disabled={ loading } onClick={ this._handleClose } type='button'>Cancel</Button>
            <Button className='form__button form__button--green' loading={ loading } type='submit'>Save</Button>
          </div>
        </form>
      );
    }

    return element;
  }
}

const mapStateToProps = (state) => {
  return {
    doctor:     state.get('doctor'),
    formValues: getFormValues(FORM_NAME)(state),
    tooltip:    state.get('tooltip')
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    close: (id) => {
      dispatch(tooltipHide({ id: id }));
      dispatch(destroy(FORM_NAME));
    },

    clearForm: () => {
      dispatch(destroy(FORM_NAME));
    },

    createAvailability: (params) => {
      dispatch(doctorAvailabilitiesCreate(params));
    },

    deleteAvailability: (params) => {
      dispatch(doctorAvailabilitiesDelete(params));
    },

    initForm: (form) => {
      dispatch(initialize(FORM_NAME, form, { keepDirty: true }));
    },

    show: (id) => {
      dispatch(tooltipShow({ id: id }));
    }
  };
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(
    reduxForm(
      { form: FORM_NAME }
    )(AvailableDoctorsTooltip)
  )
);



// WEBPACK FOOTER //
// ./app/components/managers/calendar/_AvailableDoctorsTooltip.jsx